import { Button } from "primereact/button";

const Botonera = ({
  rowData,
  variant,
  isSack,
  onVer,
  onMail,
  onHistoria,
  onRecotizar,
  onFases,
  onEditar,
  onDescartar,
  onFinalizar,
  onPublicar,
  onValidar,
}) => {
  if (variant === "BLOQUEADA") {
    return (
      <div className="flex gap-2 justify-content-start flex-wrap">
        {onVer && (
          <Button
            icon="pi pi-search"
            className="p-button-rounded p-button-info p-button-sm"
            tooltip="Visualizar"
            tooltipOptions={{ position: "top" }}
            aria-label="Visualizar"
            onClick={() => onVer(rowData)}
          />
        )}
        {onValidar && (
          <Button
            icon="pi pi-check"
            className="p-button-rounded p-button-success p-button-sm"
            tooltip="Validar"
            tooltipOptions={{ position: "top" }}
            aria-label="Validar"
            onClick={() => onValidar(rowData)}
          />
        )}
        {onDescartar && (
          <Button
            icon="pi pi-times"
            className="p-button-rounded p-button-danger p-button-sm"
            tooltip="Descartar"
            tooltipOptions={{ position: "top" }}
            aria-label="Descartar"
            onClick={() => onDescartar(rowData)}
          />
        )}
      </div>
    );
  }

  if (variant === "TIEMPO") {
    return (
      <div className="flex gap-2 justify-content-start">
        {onVer && (
          <Button
            icon="pi pi-search"
            className="p-button-rounded p-button-info p-button-sm"
            tooltip="Visualizar"
            tooltipOptions={{ position: "top" }}
            aria-label="Visualizar"
            onClick={() => onVer(rowData)}
          />
        )}
      </div>
    );
  }

  if (variant === "COTIZACION") {
    return (
      <div className="flex gap-2 justify-content-start flex-wrap">
        {onVer && (
          <Button
            icon="pi pi-search"
            className="p-button-rounded p-button-info p-button-sm"
            tooltip="Ver cotización"
            tooltipOptions={{ position: "top" }}
            aria-label="Ver cotización"
            onClick={() => onVer(rowData)}
          />
        )}
        {onEditar && (
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-primary p-button-sm"
            tooltip="Editar"
            tooltipOptions={{ position: "top" }}
            aria-label="Editar"
            onClick={() => onEditar(rowData)}
          />
        )}
        {onDescartar && (
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-danger p-button-sm"
            tooltip="Eliminar"
            tooltipOptions={{ position: "top" }}
            aria-label="Eliminar"
            onClick={() => onDescartar(rowData)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-column gap-2">
      <div className="flex gap-2 justify-content-start">
        {onVer && (
          <Button
            icon="pi pi-search"
            className="p-button-rounded p-button-info p-button-sm"
            tooltip="Ver"
            tooltipOptions={{ position: "top" }}
            aria-label="Ver"
            onClick={() => onVer(rowData)}
          />
        )}
        {onMail && (
          <Button
            tooltip="Mail"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-envelope"
            className="p-button-rounded p-button-info p-button-sm"
            aria-label="Mail"
            onClick={() => onMail(rowData)}
          />
        )}
        {variant !== "NOTAVENTA" && onEditar && (
          <Button
            tooltip="Editar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-pencil"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Editar"
            onClick={() => onEditar(rowData)}
          />
        )}
        {variant !== "NOTAVENTA" && onPublicar && (
          <Button
            tooltip="Publicar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-flag"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Publicar"
            onClick={() => onPublicar(rowData)}
          />
        )}
        {variant === "NOTAVENTA" && onValidar && (
          <Button
            tooltip="Validar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-check"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Validar"
            onClick={() => onValidar(rowData)}
          />
        )}
      </div>
      <div className="flex gap-2 justify-content-start">
        {onHistoria && (
          <Button
            tooltip="Historia"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-history"
            className="p-button-rounded p-button-info p-button-sm"
            aria-label="Historia"
            onClick={() => onHistoria(rowData)}
          />
        )}
        {isSack && onRecotizar && (
          <Button
            tooltip="Recotizar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-refresh"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Recotizar"
            onClick={() => onRecotizar(rowData)}
          />
        )}
        {isSack && onFases && (
          <Button
            tooltip="Fases"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-list"
            className="p-button-rounded p-button-info p-button-sm"
            aria-label="Fases"
            onClick={() => onFases(rowData)}
          />
        )}
        {variant !== "NOTAVENTA" && onDescartar && (
          <Button
            tooltip="Descartar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-times"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Descartar"
            onClick={() => onDescartar(rowData)}
          />
        )}
        {isSack && onFinalizar && (
          <Button
            tooltip="Finalizar"
            tooltipOptions={{ position: "top" }}
            icon="pi pi-check"
            className="p-button-rounded p-button-primary p-button-sm"
            aria-label="Finalizar"
            onClick={() => onFinalizar(rowData)}
          />
        )}
      </div>
    </div>
  );
};

export default Botonera;
